export enum EventType {
  LECTURE = 'LECTURE',
  EXERCISE = 'EXERCISE',
  EXAM = 'EXAM',
  CONSULT = 'CONSULT',
}
